<template>
  <div class="podcast-section-track">
    <div v-if="loading" class="text-gray-600">
      Loading...
    </div>

    <div v-else>
      <FormSection>
        <FormRow label="Scegli la traccia audio">
          <v-audio
            v-model="modelData.track"
            :visualElementsCount="modelData.visualElementsCount"
            :id="nameAudio()"
            :name="nameAudio()"
            :podcast-id="id"
          />
        </FormRow>
      </FormSection>
    </div>
  </div>
</template>

<script>
import PodcastSectionBase from './PodcastSectionBase'
import GET_PODCAST_TRACK_VISUAL_ELEMENTS_LENGTH from '@/graphql/GetPodcastTrackAndVisualElementsLength.gql'
import UPDATE_PODCAST_TRACK from '@/graphql/UpdatePodcastTrack.gql'

export default {
  extends: PodcastSectionBase,
  section: {
    query() {
      return {
        query: GET_PODCAST_TRACK_VISUAL_ELEMENTS_LENGTH,
        variables: { podcastId: this.id },
      }
    },
    mutation() {
      return this.$apollo.mutate({
        mutation: UPDATE_PODCAST_TRACK,
        variables: {
          id: this.id,
          track: this.modelData.track,
        },
      })
    },
    model: {
      track: {
        url: null,
        length: null,
      },
      visualElementsCount: -1,
    },
    saveModel: data => {
      const realData = data.findPodcastByID
      let elementsCount = -1
      if (
        realData.visualElements &&
        realData.visualElements.data &&
        realData.visualElements.data.length
      ) {
        elementsCount = realData.visualElements.data.length
      }
      return {
        track: { ...(realData.track || {}) },
        visualElementsCount: elementsCount,
      }
    },
  },
  methods: {
    nameAudio() {
      return `uploadaudio${this.id}`
    },
  },
}
</script>

<style lang="scss" scoped></style>
